import { CROSSBORDER_STATUS } from "../constants";

export const CrossborderStatusBadge = ({ status }) => {
  const meta = CROSSBORDER_STATUS[status] ?? {
    label: status,
    badgeClass: "bg-gray-100 text-gray-600 dark:bg-brand-dark-elevated dark:text-gray-300",
  };

  return (
    <span
      className={`inline-flex rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${meta.badgeClass}`}
    >
      {meta.label}
    </span>
  );
};
